<template>
  <div class="detail_main bg_detail is-scrollable has-background-white">
    <div class="detail_img_info">
      <a
        class="button has-text-white is-rounded diapo_button"
        @click="$parent.show = false">
        <span class="icon">
          <b-icon
            icon="chevron-left">
          </b-icon>
        </span>
        <label>Retour</label>
      </a>
      <img :src="url" class="imageBgOpp imgGoToTop">
    </div>
    <div class="leftVert topViolet rightVert bottomVert">
      <div class="tabs bottomVert">
        <ul class="p_size12 has-text-weight-bold">
          <li :class="{'underline is-active': active === 1}"
              @click="active = 1"
              class="is-paddingless">
            <a>Caractéristiques</a>
          </li>
          <li :class="{'underline is-active': active === 2}"
              @click="active = 2"
              class="is-paddingless">
            <a>Visibilité</a>
          </li>
        </ul>
      </div>
      <div class="columns is-mobile is-marginless is-multiline color-icon"
           v-if="active === 1">
        <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="barcode"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Code face
                    </label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.facCode}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="panorama-wide-angle"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Panneau
                    </label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.panCode}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="vector-intersection"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Format
                    </label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.format}}
                    </p>
                  </div>
                </div>
              </div>
              <div class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="package-variant-closed"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Matériel
                    </label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">
                      {{detailReseauxLcComplet.materiel}}
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="sign-text"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Support
                    </label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">
                      Non reseigné
                    </p>
                  </div>
                </div>
              </div>
              <div
                class="column is-paddingless is-6 bottomViolet">
                <div class="media">
                  <b-icon
                    icon="lightbulb-on-outline"
                    size="is-medium"
                    class="media-left">
                  </b-icon>
                  <div class="media-content is-size-7">
                    <label class="has-text-default">
                      Éclairé
                    </label><br>
                    <p class="p_size12 has-text-weight-bold has-text-link">
                      {{eclaire}}
                    </p>
                  </div>
                </div>
              </div>
      </div>
      <div class="columns is-mobile is-marginless is-multiline color-icon"
           v-if="active === 2">
        <div class="column is-paddingless is-6 bottomViolet">
          <div class="media">
            <b-icon
              icon="map-marker-circle"
              size="is-medium"
              class="media-left">
            </b-icon>
            <div class="media-content is-size-7">
              <label class="has-text-default">
                Localisation
              </label><br>
              <p class="p_size12 has-text-weight-bold has-text-link">
                {{detailReseauxLcComplet.localisation ?
                  detailReseauxLcComplet.localisation :
                  'Non renseigné'}}
              </p>
            </div>
          </div>
        </div>
        <div class="column is-paddingless is-6 bottomViolet">
          <div class="media">
            <b-icon
              icon="angle-obtuse"
              size="is-medium"
              class="media-left">
            </b-icon>
            <div class="media-content is-size-7">
              <label class="has-text-default">
                Angle de vision
              </label><br>
              <p class="p_size12 has-text-weight-bold has-text-link">
                {{detailReseauxLcComplet.angleDeVision ?
                  detailReseauxLcComplet.angleDeVision :
                  'Non renseigné'}}
              </p>
            </div>
          </div>
        </div>
        <div class="column is-paddingless is-6 bottomViolet">
          <div class="media">
            <b-icon
              icon="arrow-right"
              size="is-medium"
              class="media-left">
            </b-icon>
            <div class="media-content is-size-7">
              <label class="has-text-default">
                En venant de
              </label><br>
              <p class="p_size12 has-text-weight-bold has-text-link">
                {{detailReseauxLcComplet.enVenantDe ?
                  detailReseauxLcComplet.enVenantDe :
                  'Non renseigné'}}
              </p>
            </div>
          </div>
        </div>
        <div class="column is-paddingless is-6 bottomViolet">
          <div class="media">
            <b-icon
              icon="arrow-left"
              size="is-medium"
              class="media-left">
            </b-icon>
            <div class="media-content is-size-7">
              <label class="has-text-default">
                En allant vers
              </label><br>
              <p class="p_size12 has-text-weight-bold has-text-link">
                {{detailReseauxLcComplet.enAllantVers ?
                  detailReseauxLcComplet.enAllantVers :
                  'Non renseigné'}}
              </p>
            </div>
          </div>
        </div>
        <div class="column is-paddingless bottomViolet">
          <div class="media">
            <b-icon
              icon="map-marker"
              size="is-medium"
              class="media-left">
            </b-icon>
            <div class="media-content is-size-7">
              <label class="has-text-default">
                Adresse
              </label><br>
              <p class="p_size12 has-text-weight-bold has-text-link">
                {{adresse}}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { formatEclaire, formatAdresse, urlPhoto } from '@/services/opportunite/formatTab';

export default {
  name: 'detailReseauxLcComplet',
  props: ['detailReseauxLcComplet'],
  data() {
    return {
      active: 1,
      select: true,
    };
  },
  computed: {
    eclaire() {
      return formatEclaire(this.detailReseauxLcComplet.eclaire);
    },
    adresse() {
      return formatAdresse(this.detailReseauxLcComplet);
    },
    url() {
      return urlPhoto(this.detailReseauxLcComplet.urlPhoto);
    },
  },
  mounted() {
    const test = document.querySelector('html');
    test.style.overflow = 'hidden';
  },
  destroyed() {
    const test = document.querySelector('html');
    test.style.overflow = '';
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/opportuniteClient/ismobile/propositions/reseauxLc/detailReseauxLcComplet.vue